module.exports = __webpack_public_path__ + "img/4.abc8fbc5.png";